import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { NovedadesTiempos } from '../../../../models/novedadesTiempos';
import { NovedadesTiemposService } from '../../../../services/novedades-tiempos.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-novedades-tiempos-list',
  templateUrl: './novedades-tiempos-list.component.html',
  styleUrls: ['./novedades-tiempos-list.component.css']
})
export class NovedadesTiemposListComponent implements OnInit {

  @Input() personalId: number;
  @Input() novedadesTiempos: NovedadesTiempos[];
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<NovedadesTiempos>();

  novedadesOri: NovedadesTiempos[];
  novedadesGrupo: NovedadesTiempos[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private novedadesTiempoService: NovedadesTiemposService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.novedadesOri = this.novedadesTiempos;
    this.inicializaFiltros();
    
    this.filtrarNovedades();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarNovedades()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.novedadesTiempos = this.novedadesOri.filter(i => Date.parse(i.fecha) <= hasta.getTime() && Date.parse(i.fecha) >= desde.getTime());
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.novedadesGrupo == undefined)
      {
        this.novedadesTiempoService.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
            });

            this.novedadesGrupo = data;
            this.novedadesTiempos = this.novedadesGrupo;
          });

      } else
      {
        this.novedadesTiempos = this.novedadesGrupo;
      }
      
    } else
    {
      this.filtrarNovedades();
    }
  }

  onChangeFiltros()
  {
    this.filtrarNovedades();
  }

  visualizarDetalle(novedad)
  {
    this.VisualizarDetalle.emit(novedad);
  }

  add()
  {
    let novedadTiempo: NovedadesTiempos = { id: 0, personal: this.personalId, cantidad: 0, importe: 0, motivo: "", fecha: new Date().toString(), unidadMedida: "" };
    this.VisualizarDetalle.emit(novedadTiempo);
  }
}
